<template>
    <div class="bill-card bcw">
        <div class="clear fs2">
            <div v-if="bill.status=='audited'" class="left green">提现成功</div>
            <div v-else-if="bill.status=='refused'" class="left red">提现失败</div>
            <div v-else-if="bill.status=='applying'" class="left green">处理中...</div>
            <div class="right red">金额：{{bill.amount}}</div>
        </div>
        <div class="mtn fs1 c9">时间：{{time}}</div>
        <div v-if="bill.status=='refused'" class="mtn fs1 c9">原因：{{bill.refusedReason}}</div>
    </div>
</template>
<script>
import moment from 'moment';
moment.locale('zh-cn');

export default {
    name: 'BillCard',
    props: {
      bill: {
        type: Object,
      }
    },
    computed: {
        time: function () {
            return moment(this.bill.createdTime*1000).format('YYYY-MM-DD HH:mm:ss')
        }
    }
}
</script>
<style lang="less">
.bill-card{
    padding: .1rem .15rem;
    border-bottom: 1px solid #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawCard.vue